module.exports = __webpack_public_path__ + "static/media/Neighborhood_workplace_safety.56bf634f.png";